import { createReducer } from 'typesafe-actions'
import { callOrderComplete, callOrderCompleteAsync } from '../actions/app/orderComplete.actions'
import { startCheckout } from '../actions/app/checkout.actions'
import isOrderHandoverError from '../../utils/isOrderHandoverError'

export const defaultState: boolean = false

const orderHandoverFailedReducer = createReducer(defaultState)
    .handleAction(startCheckout, () => false)
    .handleAction(callOrderComplete, () => false)
    .handleAction(callOrderCompleteAsync.failure, (state, action) => isOrderHandoverError(action.payload))

export default orderHandoverFailedReducer
